import { render, staticRenderFns } from "./login-old.vue?vue&type=template&id=2710bba0&scoped=true&"
import script from "./login-old.vue?vue&type=script&lang=js&"
export * from "./login-old.vue?vue&type=script&lang=js&"
import style0 from "./login-old.vue?vue&type=style&index=0&id=2710bba0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2710bba0",
  null
  
)

export default component.exports